export const table = {
  'presiding-commissioner_tour-operator-reports': {
    path_name: 'presiding-commissioner_tour-operator-report_review',
    columns: [
      {
        name: 'review_status',
        isSortable: false,
      },
      {
        name: 'number',
        isSortable: true,
        // alignCenter: true
      },
      {
        name: 'name',
        isSortable: true,
      },
      {
        name: 'signed_at',
        type: 'date',
        isSortable: true,
      },
    ],
    tooltip: {
      approved: [
        {
          name: 'readonly',
          type_action: 'readonly',
          isRouting: true,
          handler: null,
        },
        {
          name: 'downloadPDF',
          isRouting: false,
          handler: 'downloadFile',
        },
      ],
    },
    actions: {
      approved: 'readonly',
    },
  },
  'presiding-commissioner_votes-list': {
    path_name: 'presiding-commissioner_vote-review',
    columns: [
      {
        name: 'review_status',
        isSortable: true,
      },
      {
        name: 'number',
        isSortable: true,
        // alignCenter: true
      },
      {
        name: 'name_of_legal_entity',
        isSortable: true,
      },
      {
        name: 'categorization_name',
        isSortable: true,
      },
      {
        name: 'submitted_at',
        type: 'date',
        isSortable: true,
      },
      {
        name: 'voting_at',
        type: 'date',
        isSortable: true,
      },
    ],
    tooltip: {
      waiting_for_voting: [
        {
          name: 'readonly',
          type_action: 'readonly',
          isRouting: true,
          handler: null,
        },
        // {
        //   name: 'downloadPDF',
        //   isRouting: false,
        //   handler: ''
        // },
      ],
      waiting_for_voting_date_signed: [
        {
          name: 'consider',
          type_action: 'readonly',
          isRouting: true,
          handler: null,
        },
        {
          name: 'sign_and_send',
          type_action: 'readonly',
          isRouting: false,
          handler: 'signRequestFromTable',
        },
        // {
        //   name: 'downloadPDF',
        //   isRouting: false,
        //   handler: ''
        // },
      ],
    },
    actions: {
      waiting_for_voting: 'readonly',
      waiting_for_voting_date_signed: 'readonly',
    },
  },
  'presiding-commissioner_history-list': {
    path_name: 'presiding-commissioner_history-review',
    columns: [
      {
        name: 'review_status',
        isSortable: true,
      },
      {
        name: 'number',
        isSortable: true,
        // alignCenter: true
      },
      {
        name: 'name_of_legal_entity',
        isSortable: true,
      },
      {
        name: 'categorization_name',
        isSortable: true,
      },
      {
        name: 'submitted_at',
        type: 'date',
        isSortable: true,
      },
      {
        name: 'voting_at',
        type: 'date',
        isSortable: true,
      },
    ],
    tooltip: {
      approved: [
        {
          name: 'readonly',
          type_action: 'readonly',
          isRouting: true,
          handler: null,
        },
        {
          name: 'downloadPDF',
          isRouting: false,
          handler: 'downloadFile',
        },
      ],
      declined: [
        {
          name: 'readonly',
          type_action: 'readonly',
          isRouting: true,
          handler: null,
        },
        {
          name: 'downloadPDF',
          isRouting: false,
          handler: 'downloadFile',
        },
      ],
    },
    actions: {
      approved: 'readonly',
      declined: 'readonly',
    },
  },
};
